import { CopilotResponseAnnotationsDTO } from "./copilot/copilotConversationDTO";

export default class CompanyProfileDTO {
  website?: string;

  numberOfEmployees?: number;

  industry?: string;

  companyIntelligence?: string;

  marketAndCustomers?: string;

  technologyAndRegulatory?: string;

  // null while the question is not answered
  scopeSoftwareDevelopment?: boolean | null;

  scopeFixedOffice?: boolean | null;

  annotations?: CopilotResponseAnnotationsDTO;
}